"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalculateSelector__factory = void 0;

var _contracts = require("@ethersproject/contracts");

/* Autogenerated file. Do not edit manually. */

/* tslint:disable */

/* eslint-disable */
class CalculateSelector__factory extends _contracts.ContractFactory {
  constructor(signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides) {
    return super.deploy(overrides || {});
  }

  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }

  attach(address) {
    return super.attach(address);
  }

  connect(signer) {
    return super.connect(signer);
  }

  static connect(address, signerOrProvider) {
    return new _contracts.Contract(address, _abi, signerOrProvider);
  }

}

exports.CalculateSelector__factory = CalculateSelector__factory;
const _abi = [{
  constant: true,
  inputs: [],
  name: "calculateSelector",
  outputs: [{
    internalType: "bytes4",
    name: "",
    type: "bytes4"
  }],
  payable: false,
  stateMutability: "pure",
  type: "function"
}];
const _bytecode = "0x6080604052348015600f57600080fd5b5060908061001e6000396000f3fe6080604052348015600f57600080fd5b506004361060285760003560e01c8063bb71eb3b14602d575b600080fd5b60336050565b604080516001600160e01b03199092168252519081900360200190f35b63dcce221160e01b9056fea265627a7a7231582070c755aa7da3a00a84f7f463359aa40c21e1623691fd3c54416045614b27ddcf64736f6c63430005100032";